import React from 'react';
import { copilotConfig, REDUCED_CONTEXT_MSG } from '@components/Copilot/constants';
import { AvButton, AvMessagePopover, ButtonKinds } from '@fabric-ui/components';
import { Prefix, Refresh, X } from '@fabric-ui/icons';
import { WarningFullOrange } from '@fabric-ui/icons/colorful';
import { flex } from '@fabric-ui/theme';
import { iconSize } from '@fabric-ui/utils';
import { Box, Divider, Typography } from '@mui/material';
import { useAvCopilotContext } from '../../context/AvCopilotProvider';

const headerHeight = '56px';

interface ICopilotHeader {
  onClose: () => void;
  isReducedContextMode?: boolean;
}
const CopilotHeader: React.FC<ICopilotHeader> = ({ onClose, isReducedContextMode = false }) => {
  const { lastSessionProps, restartCopilotSession } = useAvCopilotContext();
  return (
    <Box sx={{ ...flex.colJustifyCenter, position: 'relative', height: headerHeight }}>
      <Box sx={{ ...flex.itemsCenter, gap: 1, pl: 3 }}>
        <Prefix style={iconSize(18)} fill="var(--dataviz-color-sequential-blue-scale06)" />
        <Typography
          variant="h5"
          sx={({ palette }) => ({ background: palette.gradients.primary, backgroundClip: 'text', WebkitTextFillColor: 'transparent' })}>
          {copilotConfig[lastSessionProps.agentId]?.title || 'Copilot'}
        </Typography>
      </Box>
      <Box sx={{ ...flex.itemsCenter, gap: 1, position: 'absolute', right: 24 }}>
        {isReducedContextMode && (
          <AvMessagePopover
            message={<Box sx={{ width: 285 }}>{REDUCED_CONTEXT_MSG}</Box>}
            includeIconInMessage
            icon={<WarningFullOrange />}
            asTooltip
          />
        )}
        <AvButton kind={ButtonKinds.ICON} tooltip="Reset Chat" size="small" onClick={restartCopilotSession}>
          <Refresh style={iconSize(22)} />
        </AvButton>
        <Divider orientation="vertical" sx={{ height: 24, alignSelf: 'center' }} />
        <AvButton kind={ButtonKinds.ICON} size="small" onClick={onClose}>
          <X style={iconSize(22)} />
        </AvButton>
      </Box>
    </Box>
  );
};

const MemoizedCopilotHeader = React.memo(CopilotHeader);

export default MemoizedCopilotHeader;
